module.exports = __webpack_public_path__ + "62fb69a00b5d156ab93ae0700c1cf17e.png";